/**
 * @generated SignedSource<<a517f12a86849f45f23a239e2a92ee93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formDetailId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormDetailUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFormDetailTPayload",
        "kind": "LinkedField",
        "name": "updateFormDetailTByFormDetailId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailT",
            "kind": "LinkedField",
            "name": "formDetailT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormDetailUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFormDetailTPayload",
        "kind": "LinkedField",
        "name": "updateFormDetailTByFormDetailId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailT",
            "kind": "LinkedField",
            "name": "formDetailT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a22da936676297e6b1281f7763078e9",
    "id": null,
    "metadata": {},
    "name": "FormDetailUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation FormDetailUpdateMutation(\n  $input: UpdateFormDetailTByFormDetailIdInput!\n) {\n  updateFormDetailTByFormDetailId(input: $input) {\n    formDetailT {\n      formDetailId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c8b358f9351f0a46e732672fb7bcf80b";

module.exports = node;
